<template>
    <transition name="fade">
        <div class="overlay" v-if="$root.isSessionExpired">
            <div class="session-modal">
                <div class="session-modal__head">
                    <span>Vous serez déconnecté dans:</span>
                </div>
                <div class="session-modal__body">
                    <div class="session-modal__body__timer">
                        <span class="session-modal__body__timer__digits">{{count}} </span>
                        <span class="session-modal__body__timer__sec">sec</span>
                    </div>
                    <div class="session-modal__body__text">
                        Votre session va bientôt expirer.
                        <br>
                        <br>
                        Voulez-vous prolonger votre session ou vous déconnecter ?
                    </div>
                    <div class="session-modal__body__controls">
                        <button class="blue" @click="continueSession">
                            <span>Continuer la session</span>
                        </button>
                        <button class="transparent" @click="logOutNow">
                            <span>Deconnecter</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        name: 'EndSessionModal',
        data() {
            return {
            }
        },
        props: {
            count: Number
        },
        methods: {
            continueSession() {
                this.$eventBus.$emit('session_expired:continue_session');
            },
            logOutNow() {
                this.$root.sessionExpired = false;
                this.$root.logOut(
                    () => this.$store.dispatch('sessionExpired'),
                    () => this.$store.dispatch('sessionExpired')
                );
            },
        },
    }


</script>



// WEBPACK FOOTER //
// src/components/SessionExpiredModal.vue